/* eslint-disable indent */
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { ResumoModalComponent } from '../modals/resumo-modal/resumo-modal.component';
import {
  AcaoAcompanhamento,
  AnaliseDescontoStatus,
  EtapaDoPedido,
  PerfilDoUsuario,
  StatusDoPedido,
  TipoFila,
  TipoFiltroDataMonitor,
  TipoTag
} from '../models/enum';
import { Etapa } from '../models/etapa';
import { Pedido } from '../models/pedido';
import { PedidoLista } from '../models/pedido-lista';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PedidoService } from '../services/pedido.service';
import { UtilitarioService } from '../services/utilitario.service';
import { EtapaService } from 'src/app/services/etapa.service';
import { ResumoFinanceiroModalComponent } from './../modals/resumo-financeiro-modal/resumo-financeiro-modal.component';
import swal from 'sweetalert2';
import { EtapaPedido } from '../models/etapa-pedido';
import { JustificativaModalComponent } from './../modals/justificativa-modal/justificativa-modal.component';
import { NotaFiscalService } from '../services/nota-fiscal.service';
import { NotaFiscalModalComponent } from './../modals/nota-fiscal-modal/nota-fiscal-modal.component';
import { VolumeModalComponent } from './../modals/volume-modal/volume-modal.component';
import { PedidoAnexoComponent } from '../pedido/pedido-anexo/pedido-anexo.component';
import { PremissasService } from '../services/premissas.service';
import { NotaFiscalPedidoModalComponent } from '../modals/nota-fiscal-pedido-modal/nota-fiscal-pedido-modal.component';
import { ObservacoesModalComponent } from '../modals/observacoes-modal/observacoes-modal.component';
import { CRMHierarquiaUsuario } from '../models/crmhierarquia-usuario';
import { CRMHierarquiaUsuarioService } from '../services/crmhierarquia-usuario.service';
import { FuncionarioService } from '../services/funcionario.service';
import { ClienteService } from '../services/cliente.service';
import { Cliente } from '../models/cliente';
import { CondicaoDePagamento } from '../models/condicao-de-pagamento';
import { FormaDePagamento } from '../models/forma-de-pagamento';
import { CondicaoDePagamentoService } from '../services/condicao-de-pagamento.service';
import { FormaDePagamentoService } from '../services/forma-de-pagamento.service';
import { SelecionarTagModalComponent } from '../modals/selecionar-tag-modal/selecionar-tag-modal.component';
import { TagGi } from '../models/tag-gi';
import { TagGiService } from '../services/tag-gi.service';
import { PedidoRecebimentoModalComponent } from '../modals/pedido-recebimento-modal/pedido-recebimento-modal.component';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { SelecionarArquivoBoletoPedidoModalComponent } from '../modals/selecionar-arquivo-boleto-pedido-modal/selecionar-arquivo-boleto-pedido-modal.component';
import { SelecionarOcorrenciaModalComponent } from '../modals/selecionar-ocorrencia-modal/selecionar-ocorrencia-modal.component';
import { Fornecedor } from '../models/fornecedor';
import { FornecedorService } from '../services/fornecedor.service';
import { DadosMonitoresModalComponent } from '../modals/dados-monitores-modal/dados-monitores-modal.component';
import { MonitorService } from '../services/monitor.service';
import { UsuarioLogado } from '../models/usuario-logado';
import { EtapasDoPedidoComponent } from '../pedido/etapas-do-pedido/etapas-do-pedido.component';
import { PaginatorService } from '../services/paginator.service';
import { CadastrarPendenciaModalComponent } from '../modals/cadastrar-pendencia-modal/cadastrar-pendencia-modal.component';
import { Pendencia } from '../models/pendencia';
import { PendenciaService } from '../services/pendencia.service';
import { PremissasSistema } from '../models/premissas-sistema';
import { AnaliseDescontoSolicitacaoModalComponent } from '../modals/analise-desconto-solicitacao-modal/analise-desconto-solicitacao-modal.component';
import { Observable, Subscription } from 'rxjs';
import { SumarioPedidoMonitor } from '../models/sumario-pedido-monitor';
import { FilaService } from '../services/fila.service';
import { VendaItemLotesModalComponent } from '../modals/venda-item-lotes-modal/venda-item-lotes-modal.component';

declare const $: any;

@Component({
  selector: 'app-acompanhamento',
  templateUrl: './acompanhamento.component.html',
  styleUrls: ['./acompanhamento.component.scss']
})
export class AcompanhamentoComponent implements OnInit, OnDestroy {
  // variáveis
  pedidosFiltrados: PedidoLista[] = [];
  carregando = true;
  campoOrdenacao = 'dataEtapa';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  etapas: Etapa[] = [];
  todasEtapas: Etapa[] = [];
  etapaSelecionada = undefined;
  somenteApi = false;
  tipoNota = 0;
  ordemSelecionada = 0;

  fornecedores: Fornecedor[] = [];

  buscouTotais = false;
  spinnerTotais = false;
  boletoFotus = false;

  usuarioLogado: UsuarioLogado;

  mostrarRecebimentos = false;
  visualizacaoSelecionada = 0;

  multiFornecedores = false;
  pCentroDistribuicao = false;

  pedirCodErpIntegracao = false;
  informarDadosSeparacao = false;

  soma = 0;
  potenciaTotal = 0;

  StatusDoPedido = StatusDoPedido;
  PerfilDoUsuario = PerfilDoUsuario;

  AcaoAcompanhamento = AcaoAcompanhamento;

  perfil: PerfilDoUsuario;

  filtroPedido = { ...this.filtroPedidoLimpo() };

  permissoesPedidoFuncionario = {
    podeEditarFrete: false,
    podeEditarServicoEntrega: false,
    podeEditarSeguro: false,
    podeDescontoIndividual: false,
    podeVerTotaisMonitores: false
  };

  integrador = false;
  tipo = 0;
  // nomeFiltro = '';
  titulo = '';
  textoBotaoAcao = '';
  iconeBotaoAcao = '';
  icone = '';

  visibilidade = {
    resumo: false,
    resumoFinanceiro: false,
    editar: false,
    aprovar: false,
    reprovar: false,
    separar: false,
    despachar: false,
    entregar: false,
    verJustificativa: false,
    vincularNota: false,
    imprimirNota: false,
    conferir: false,
    anexos: false,
    faturar: false,
    integrar: false,
    aguardarValidacao: false,
    aguardarIntegracao: false,
    verRecebimentos: false,
    podeEditarRecebimentos: false,
    tagsDoPedido: true,
    conferirTec: false,
    verificarTec: false,
    aprovarBancoTec: false,
    aprovarFinanceiroTec: false,
    faturarTec: false,
    emPendencia: false,
    resolverPendencia: false,
    aprovarTriagem: false,
    ordenacao: false,
    historico: false,
    aprovarPedido: false,
    aguardarTriagem: false,
    emSeparacao: false,
    emImportacao: false,
    conferirPagamento: false,
    verProdutoLote: false
  };

  ordenacoesTriagem = [
    { id: 0, nome: 'Entrada na etapa ' },
    { id: 1, nome: 'Potência' }
  ];
  direcaoTriagem = 'asc';
  ordenacaoTriagem = 0;

  dadosObgMonitores = true;
  statusPedido = [
    { id: undefined, nome: 'Todos' },
    { id: StatusDoPedido.Ativo, nome: 'Ativo' },
    { id: StatusDoPedido.Cancelado, nome: 'Cancelado' },
    { id: StatusDoPedido.Expirado, nome: 'Expirado' }
  ];
  tiposFiltroData = [
    { id: TipoFiltroDataMonitor.NaEtapa, descricao: 'Na etapa' },
    { id: TipoFiltroDataMonitor.PassouNaEtapa, descricao: 'Passou na etapa' }
  ];
  vendedores: CRMHierarquiaUsuario[] = [];
  administrador = false;
  clientes: Cliente[] = [];

  formasDePagamento: FormaDePagamento[] = [];
  formaDePagamentoSelecionado: number[] = [];
  condicoesDePagamento: CondicaoDePagamento[] = [];
  condicaoDePagamentoSelecionado: number[] = [];
  tipoFiltroDataSelecionado = 0;
  tags: TagGi[] = [];
  tagsSelecionadas = [];

  mostrarPesquisaGeral = false;
  monitores = [];

  modulosAtivos: Number[] = [];

  verExcel = false;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  buscouPedidos = true;

  bloquearSistema: boolean = false;

  pendencias: Pendencia[] = [];
  pendenciasSelecionadas: number[] = [];

  tiposFiltroSimNao = [
    { id: 1, descricao: 'Sim' },
    { id: 0, descricao: 'Não' }
  ];
  tiposDeFrete = [
    { id: 0, descricao: 'CIF' },
    { id: 1, descricao: 'FOB' }
  ];
  entregaRuralSelecionada = undefined;
  possuiVendaDireta = undefined;
  valorFiltroDescontoDe = undefined;
  valorFiltroDescontoAte = undefined;
  possuiServico = undefined;
  tipoFrete = undefined;
  tipoPendencia = 0;
  substituicao = undefined;

  premissas: PremissasSistema = new PremissasSistema();

  itensSimNaoBooleano = [
    { valor: true, descricao: 'Sim' },
    { valor: false, descricao: 'Não' }
  ];

  pesquisaPorTimes = false;
  cidadeCDItens = [
    { id: -1, descricao: 'Todos' },
    { id: 0, descricao: 'Fora' },
    { id: 1, descricao: 'Dentro' }
  ];

  etapasFiltro: Etapa[] = [];
  etapasFiltroSelecionadas: number[] = [];

  mostrarBotoes = true;

  private subscriptionPedidos$: Subscription;
  private subscriptionTotais$: Subscription;
  private subscriptionsPedidoSumario$: Subscription[] = [];

  constructor(
    private pedidoService: PedidoService,
    public utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    private router: Router,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private etapaService: EtapaService,
    private funcionarioService: FuncionarioService,
    private notaFiscalService: NotaFiscalService,
    private premissasService: PremissasService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private clienteService: ClienteService,
    private formadePagamentoService: FormaDePagamentoService,
    private condicaoDePagamentoService: CondicaoDePagamentoService,
    private tagService: TagGiService,
    private fornecedorService: FornecedorService,
    private monitorService: MonitorService,
    private pendenciaService: PendenciaService,
    private paginatorService: PaginatorService,
    private datePipe: DatePipe,
    private filaService: FilaService
  ) {}

  async ngOnInit() {
    await this.buscarPremissasSistema();

    this.usuarioLogado = await this.globalService.consultaUsuario();
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    await this.buscarModulosAtivos();

    this.administrador = await this.globalService.administrador();
    this.integrador = await this.globalService.integrador();
    this.perfil = await this.globalService.perfil();

    this.buscarMonitores();
    await this.buscarPermissoesFuncionario();
    await this.buscarPremissaCentroDeDistribuicao();

    if (this.pCentroDistribuicao) {
      await this.buscarIdCDPadrao();
    }

    this.buscarMostrarPesquisaGeral();
    this.buscarMultiFornecedores();
    this.buscarFornecedores();
    this.buscarPedirCodErpIntegracao();
    this.buscarInformarDadosSeparacao();
    this.buscarPremissasBloqueioSistema();

    this.route.data.subscribe(async (data: Data) => {
      this.tipo = data['tipo'];

      this.buscarVendedores();
      this.buscarFormasDePagamento();
      this.buscarTags();
      this.buscarPremissaBoletoFotus();

      switch (this.tipo) {
        // vendas
        case 0:
          this.titulo = 'Monitoramento Vendas';
          this.icone = 'shopping_cart';
          break;

        // Conferência
        case 1:
          this.titulo = 'Monitoramento Integração';
          this.icone = 'attach_money';
          break;

        // financiamento
        case 2:
          this.titulo = 'Monitoramento Financiamento';
          this.icone = 'attach_money';
          break;

        // financeiro
        case 3:
          this.titulo = 'Monitoramento Financeiro';
          this.icone = 'attach_money';
          break;

        // fiscal
        case 4:
          this.titulo = 'Monitoramento Separação';
          this.icone = 'request_quote';
          break;

        // almoxarifado
        case 5:
          this.titulo = 'Monitoramento Fiscal';
          this.icone = 'shopping_bag';
          break;

        // expedição
        case 6:
          this.titulo = 'Monitoramento Expedição';
          this.icone = 'local_shipping';
          break;

        // expedição
        case 10:
          this.titulo = 'Monitoramento Pedidos';
          this.icone = 'list_alt';

          $('#collapseExample').addClass('show');
          break;

        // conferência
        case 12:
          this.titulo = 'Monitoramento Conferência';
          this.icone = 'checklist_rtl';

          if (this.premissas.usarMonitorConferenciaFilaTarefa) {
            this.mostrarBotoes = false;

            if (!this.administrador && !(await this.eGestor(TipoFila.MonitorConferencia))) {
              this.router.navigate(['/']);
            }
          }

          break;

        // verificação
        case 13:
          this.titulo = 'Monitoramento Verificação';
          this.icone = 'fact_check';
          break;

        // análise
        case 14:
          this.titulo = 'Monitoramento Análise Financeira';
          this.icone = 'local_atm';
          break;

        // Faturamento
        case 15:
          this.titulo = 'Monitoramento Faturamento';
          this.icone = 'price_check';
          break;

        // Triagem
        case 16:
          await this.buscarPendencias();
          this.titulo = 'Monitoramento Triagem';
          this.icone = 'filter_list';
          break;

        // Pendência
        case 17:
          await this.buscarPendencias();
          this.titulo = 'Monitoramento Pendências';
          this.icone = 'pending_actions';
          break;

        default:
          break;
      }

      if (this.perfil === PerfilDoUsuario.Vendedor && (this.tipo === 0 || this.tipo === 17)) {
        this.filtroPedido.funcionario = this.usuarioLogado.id;
      }

      if (this.tipo !== 10) {
        this.buscarEtapas();
      } else {
        this.buscarEtapasFiltro();
      }

      this.buscarTodasEtapas();
      this.filtroPedido.status = 0;
      this.buscarDadosObgMonitores();
    });

    this.verExcel = this.usuarioLogado.verExcel;
  }

  async eGestor(tipoFila: TipoFila) {
    try {
      this.carregandoService.mostra('eGestor');
      return await this.filaService.eGestor(tipoFila).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('eGestor');
    }
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra('buscarBloqSist');
    this.premissasService.consultarBloqSistManuProd().subscribe(
      (data) => {
        this.bloquearSistema = data;
        this.carregandoService.esconde('buscarBloqSist');
      },
      (erro) => {
        this.carregandoService.esconde('buscarBloqSist');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissas = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some((p) => p === modulo);
  }

  async buscarModulosAtivos() {
    try {
      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  async buscarPermissoesFuncionario() {
    try {
      this.permissoesPedidoFuncionario = await this.funcionarioService.consultarPermissoesPedido().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  buscarMostrarPesquisaGeral() {
    this.premissasService.consultarMostrarPesquisaGeral().subscribe(
      (f) => {
        this.mostrarPesquisaGeral = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMultiFornecedores() {
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.multiFornecedores = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPedirCodErpIntegracao() {
    this.premissasService.consultarPedirCodErpIntegracao().subscribe(
      (f) => {
        this.pedirCodErpIntegracao = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarInformarDadosSeparacao() {
    this.premissasService.consultarInformarDadosSeparacao().subscribe(
      (f) => {
        this.informarDadosSeparacao = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarIdCDPadrao() {
    try {
      const idCDPadrao = await this.funcionarioService.consultarIdCDPadrao().toPromise();
      if (idCDPadrao !== null && idCDPadrao !== undefined) {
        this.filtroPedido.idFornecedor = idCDPadrao;
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.pCentroDistribuicao = (await this.premissasService.consultarCentroDeDistribuicao().toPromise()).valor;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  buscarFornecedores() {
    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.fornecedores = forn;
      },
      (err) => {
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarEtapas() {
    this.etapaService.consultarPorTipoDeAcompanhamento(this.tipo).subscribe(
      (resp) => {
        this.etapas = resp;

        if (!this.etapaSelecionada) {
          this.etapaSelecionada = this.etapas[0].id;
          this.somenteApi = this.etapas[0].somenteApi;
        }
        this.buscarPedidos();
        this.consultarTotais();
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarEtapasFiltro() {
    this.carregandoService.mostra('buscarEtapasFiltro');

    this.etapaService.consultarParaFiltro().subscribe(
      (resp) => {
        this.etapasFiltro = resp;
        this.carregandoService.esconde('buscarEtapasFiltro');
      },
      (erro) => {
        this.carregandoService.esconde('buscarEtapasFiltro');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarTodasEtapas() {
    this.etapaService.consultar().subscribe(
      (resp) => {
        this.todasEtapas = resp;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize
      });
    }

    return false;
  }

  ordenarTriagem() {
    this.direcaoTriagem = this.direcaoTriagem === 'asc' ? 'desc' : 'asc';
    this.buscarPedidos();
    return false;
  }

  ordenarTipoPendencia() {
    this.tipoPendencia = this.tipoPendencia === 0 ? 1 : 0;
    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarPedidos();
    this.consultarTotais();
    this.paginator.firstPage();
  }

  consultarTotais() {
    this.buscouTotais = false;
    this.spinnerTotais = true;

    if (!this.podePesquisar()) {
      return;
    }

    if (this.tipo !== 10) this.filtroPedido.etapas = this.etapaSelecionada ? [this.etapaSelecionada] : [];
    else this.filtroPedido.etapas = this.etapasFiltroSelecionadas;

    this.filtroPedido.pendencias = this.pendenciasSelecionadas ? [this.pendenciasSelecionadas] : [];

    let etapas = undefined;
    let pendencias = undefined;
    let formas = undefined;
    let condicoes = undefined;

    if (this.filtroPedido.etapas && this.filtroPedido.etapas.length > 0) {
      etapas = this.filtroPedido.etapas.join(',');
    }

    if (this.filtroPedido.pendencias && this.filtroPedido.pendencias.length > 0) {
      pendencias = this.filtroPedido.pendencias.join(',');
    }

    if (this.formaDePagamentoSelecionado && this.formaDePagamentoSelecionado.length > 0) {
      formas = this.formaDePagamentoSelecionado.join(',');
    }

    if (this.condicaoDePagamentoSelecionado && this.condicaoDePagamentoSelecionado.length > 0) {
      condicoes = this.condicaoDePagamentoSelecionado.join(',');
    }

    this.soma = 0;
    this.potenciaTotal = 0;

    // somente valores
    this.destroySubscriptionTotais();

    this.subscriptionTotais$ = this.pedidoService
      .consultarTotalPaginacaoMonitor(
        this.filtroPedido.dtInicio ? this.filtroPedido.dtInicio.toISOString() : this.filtroPedido.dtInicio,
        this.filtroPedido.dtFim ? this.filtroPedido.dtFim.toISOString() : this.filtroPedido.dtFim,
        this.filtroPedido.nomeCliente,
        this.filtroPedido.idCupom,
        this.filtroPedido.status,
        this.filtroPedido.funcionario === 0
          ? undefined
          : this.filtroPedido.funcionario === -1
            ? this.usuarioLogado.id
            : this.filtroPedido.funcionario,
        etapas,
        false,
        true,
        this.filtroPedido.integrador,
        this.filtroPedido.orcStatus,
        formas,
        condicoes,
        this.filtroPedido.valorDe,
        this.filtroPedido.valorAte,
        this.tagsSelecionadas !== null && this.tagsSelecionadas !== undefined && this.tagsSelecionadas.length > 0
          ? this.tagsSelecionadas.join(',')
          : undefined,
        this.tipo,
        null,
        null,
        this.tipo === 10 ? null : this.tipoFiltroDataSelecionado,
        null,
        this.filtroPedido.referencia,
        this.filtroPedido.idFornecedor,
        this.filtroPedido.codErp,
        null,
        null,
        null,
        null,
        true,
        null,
        this.filtroPedido.nfe,
        this.filtroPedido.valorComprovanteDe,
        this.filtroPedido.valorComprovanteAte,
        pendencias,
        this.entregaRuralSelecionada,
        this.possuiVendaDireta,
        this.valorFiltroDescontoDe,
        this.valorFiltroDescontoAte,
        this.possuiServico,
        this.tipoFrete,
        this.tipoPendencia,
        this.substituicao,
        this.filtroPedido.possuiRespostaAnaliseDesconto,
        this.pesquisaPorTimes,
        this.filtroPedido.cidadeCdSelecionado,
        this.filtroPedido.codErpProduto
      )
      .subscribe(
        (dados) => {
          this.soma = dados.soma;
          this.potenciaTotal = dados.potencia;
          this.paginacao.total = dados.total;
          this.buscouTotais = true;
          this.spinnerTotais = false;
        },
        (erro) => {
          this.buscouTotais = false;
          this.spinnerTotais = false;
          this.notificacaoService.erro(erro);
        }
      );
  }

  destroySubscriptionPedidos() {
    if (this.subscriptionPedidos$ !== null && this.subscriptionPedidos$ !== undefined) {
      this.subscriptionPedidos$.unsubscribe();
      this.subscriptionPedidos$ = undefined;
    }
  }

  destroySubscriptionTotais() {
    if (this.subscriptionTotais$ !== null && this.subscriptionTotais$ !== undefined) {
      this.subscriptionTotais$.unsubscribe();
      this.subscriptionTotais$ = undefined;
    }
  }

  destroySubscriptionPedidoSumario() {
    if (this.subscriptionsPedidoSumario$ !== null && this.subscriptionsPedidoSumario$ !== undefined) {
      this.subscriptionsPedidoSumario$.forEach((s) => {
        if (s !== null && s !== undefined) {
          s.unsubscribe();
          s = undefined;
        }
      });

      this.subscriptionsPedidoSumario$ = [];
    }
  }

  buscarPedidos() {
    this.buscouPedidos = false;

    if (!this.podePesquisar()) {
      return;
    }

    if (this.tipo !== 10) this.filtroPedido.etapas = this.etapaSelecionada ? [this.etapaSelecionada] : [];
    else this.filtroPedido.etapas = this.etapasFiltroSelecionadas;

    this.filtroPedido.pendencias = this.pendenciasSelecionadas ? [this.pendenciasSelecionadas] : [];

    let etapas = undefined;
    let pendencias = undefined;
    let formas = undefined;
    let condicoes = undefined;

    if (this.filtroPedido.etapas && this.filtroPedido.etapas.length > 0) {
      etapas = this.filtroPedido.etapas.join(',');
    }

    if (this.filtroPedido.pendencias && this.filtroPedido.pendencias.length > 0) {
      pendencias = this.filtroPedido.pendencias.join(',');
    }

    if (this.formaDePagamentoSelecionado && this.formaDePagamentoSelecionado.length > 0) {
      formas = this.formaDePagamentoSelecionado.join(',');
    }

    if (this.condicaoDePagamentoSelecionado && this.condicaoDePagamentoSelecionado.length > 0) {
      condicoes = this.condicaoDePagamentoSelecionado.join(',');
    }

    this.destroySubscriptionPedidos();
    this.destroySubscriptionPedidoSumario();

    this.pedidosFiltrados = [];

    this.subscriptionPedidos$ = this.pedidoService
      .consultarComPaginacaoMonitor(
        this.paginacao.paginaAtual,
        this.itensPorPagina,
        this.visualizacaoSelecionada === 0 ? 'dataetapa' : this.campoOrdenacao,
        this.visualizacaoSelecionada === 0
          ? this.visibilidade.ordenacao
            ? this.direcaoTriagem
            : 'asc'
          : this.ordenarDesc
            ? 'desc'
            : 'asc',
        this.filtroPedido.dtInicio ? this.filtroPedido.dtInicio.toISOString() : this.filtroPedido.dtInicio,
        this.filtroPedido.dtFim ? this.filtroPedido.dtFim.toISOString() : this.filtroPedido.dtFim,
        this.filtroPedido.nomeCliente,
        this.filtroPedido.idCupom,
        this.filtroPedido.status,
        this.filtroPedido.funcionario === 0
          ? undefined
          : this.filtroPedido.funcionario === -1
            ? this.usuarioLogado.id
            : this.filtroPedido.funcionario,
        etapas,
        false,
        true,
        this.filtroPedido.integrador,
        this.filtroPedido.orcStatus,
        formas,
        condicoes,
        this.filtroPedido.valorDe,
        this.filtroPedido.valorAte,
        this.tagsSelecionadas !== null && this.tagsSelecionadas !== undefined && this.tagsSelecionadas.length > 0
          ? this.tagsSelecionadas.join(',')
          : undefined,
        this.tipo,
        null,
        null,
        this.tipo === 10 ? null : this.tipoFiltroDataSelecionado,
        null,
        this.filtroPedido.referencia,
        this.filtroPedido.idFornecedor,
        this.filtroPedido.codErp,
        null,
        this.visualizacaoSelecionada === 0 && this.visibilidade.ordenacao ? this.ordenacaoTriagem : null,
        false,
        false,
        true,
        false,
        this.filtroPedido.nfe,
        this.filtroPedido.valorComprovanteDe,
        this.filtroPedido.valorComprovanteAte,
        pendencias,
        this.entregaRuralSelecionada,
        this.possuiVendaDireta,
        this.valorFiltroDescontoDe,
        this.valorFiltroDescontoAte,
        this.possuiServico,
        this.tipoFrete,
        this.tipoPendencia,
        this.substituicao,
        this.filtroPedido.possuiRespostaAnaliseDesconto,
        this.pesquisaPorTimes,
        this.filtroPedido.cidadeCdSelecionado,
        this.filtroPedido.codErpProduto
      )
      .subscribe(
        (dados) => {
          this.defineVisibilidade();

          this.pedidosFiltrados = dados.itens;

          this.buscouPedidos = true;

          this.pedidosFiltrados.forEach((p) => {
            this.subscriptionsPedidoSumario$.push(this.buscarPedidoSumario(p));

            // p.tags = await this.buscarPedidoSumario(p.idCupom);
            // p.buscouTags = true;
          });

          this.carregando = false;
        },
        (erro) => {
          this.buscouPedidos = true;
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarPedidoSumario(pedido: PedidoLista) {
    return this.pedidoService.sumarioPedidoMonitor(pedido.idCupom).subscribe(
      (sumario: SumarioPedidoMonitor) => {
        pedido.pesoBruto = sumario.pesoBruto;
        pedido.possuiAnaliseDesconto = sumario.possuiAnaliseDesconto;
        pedido.possuiAnaliseDescontoEmAndamento = sumario.possuiAnaliseDescontoEmAndamento;
        pedido.statusUltimaAnaliseDesconto = sumario.statusUltimaAnaliseDesconto;
        pedido.possuiAnexos = sumario.possuiAnexos;
        pedido.possuiOcorrencias = sumario.possuiOcorrencias;
        pedido.possuiMensagens = sumario.possuiMensagens;
        pedido.possuiNotasFiscais = sumario.possuiNotasFiscais;
        pedido.possuiPendencias = sumario.possuiPendencias;
        pedido.tags = sumario.tags;
        pedido.buscouTags = true;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );

    // try {
    //   const comLog = true;
    //   const tags = await this.tagService.consultarPorIdCupom(idCupom, comLog).toPromise();
    //   return tags;
    // } catch (erro) {
    //   this.notificacaoService.erro(erro);
    // }
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize) this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;
    this.buscarPedidos();
  }

  editarPedido(pedido: PedidoLista) {
    this.router.navigate(['/pedidos/editar', pedido.idCupom]);
  }

  filtroPedidoLimpo() {
    return {
      dtFim: undefined,
      dtInicio: undefined,
      funcionario: undefined,
      idCupom: '',
      nomeCliente: '',
      status: 0,
      etapas: [],
      integrador: undefined,
      orcStatus: undefined,
      valorDe: undefined,
      valorAte: undefined,
      referencia: undefined,
      idFornecedor: undefined,
      codErp: '',
      nfe: undefined,
      valorComprovanteDe: undefined,
      valorComprovanteAte: undefined,
      pendencias: [],
      substituicao: undefined,
      possuiRespostaAnaliseDesconto: undefined,
      cidadeCdSelecionado: -1,
      codErpProduto: undefined
    };
  }

  restaurarFiltro() {
    this.filtroPedido = { ...this.filtroPedidoLimpo() };
    this.condicaoDePagamentoSelecionado = [];
    this.formaDePagamentoSelecionado = [];
    this.tagsSelecionadas = [];
    this.pendenciasSelecionadas = [];
    this.entregaRuralSelecionada = undefined;
    this.possuiVendaDireta = undefined;
    this.valorFiltroDescontoDe = undefined;
    this.valorFiltroDescontoAte = undefined;
    this.substituicao = undefined;

    if (this.tipo === 10) {
      this.buscouPedidos = true;
      this.limpaPedidos();
    } else {
      this.buscarPedidos();
      this.consultarTotais();
    }
  }

  limpaPedidos() {
    this.pedidosFiltrados = [];

    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
  }

  defineVisibilidade() {
    this.visibilidade.despachar = false;
    this.visibilidade.entregar = false;
    this.visibilidade.separar = false;
    this.visibilidade.aprovar = false;
    this.visibilidade.reprovar = false;
    this.visibilidade.editar = false;
    this.visibilidade.resumo = true;
    this.visibilidade.resumoFinanceiro = false;
    this.visibilidade.verJustificativa = false;
    this.visibilidade.vincularNota = false;
    this.visibilidade.imprimirNota = false;
    this.visibilidade.conferir = false;
    this.visibilidade.faturar = false;
    this.visibilidade.integrar = false;
    this.visibilidade.anexos = false;
    this.visibilidade.aguardarIntegracao = false;
    this.visibilidade.aguardarValidacao = false;
    this.visibilidade.verRecebimentos = false;
    this.visibilidade.podeEditarRecebimentos = false;
    this.visibilidade.tagsDoPedido = true;
    this.visibilidade.faturarTec = false;
    this.visibilidade.conferirTec = false;
    this.visibilidade.verificarTec = false;
    this.visibilidade.aprovarBancoTec = false;
    this.visibilidade.aprovarFinanceiroTec = false;
    this.visibilidade.emPendencia = false;
    this.visibilidade.resolverPendencia = false;
    this.visibilidade.aprovarTriagem = false;
    this.visibilidade.ordenacao = true;
    this.visibilidade.historico = false;
    this.visibilidade.aprovarPedido = false;
    this.visibilidade.emSeparacao = false;
    this.visibilidade.emImportacao = false;
    this.visibilidade.verProdutoLote = false;

    let etapa = this.etapas.find((p) => p.id === this.filtroPedido.etapas[0]);
    this.ordemSelecionada = etapa ? etapa.ordem : undefined;

    const contem = this.ordenacoesTriagem.some((e) => e.id === 2);

    switch (this.tipo) {
      // vendas
      case 0:
        this.visibilidade.editar =
          etapa.ordem === EtapaDoPedido.AguardandoValidacao ||
          etapa.ordem === EtapaDoPedido.PagamentoReprovado ||
          etapa.ordem === EtapaDoPedido.PedidoForaPrazo ||
          etapa.ordem === EtapaDoPedido.Editando;
        this.visibilidade.verJustificativa = etapa.ordem === EtapaDoPedido.PagamentoReprovado;
        this.visibilidade.anexos = true;

        this.visibilidade.tagsDoPedido =
          etapa.ordem !== EtapaDoPedido.AguardandoPagamentoFinanciamento &&
          etapa.ordem !== EtapaDoPedido.AguardandoPagamentoRecursoProprio;

        break;

      // integração
      case 1:
        this.visibilidade.integrar = etapa.ordem === EtapaDoPedido.AguardandoIntegracao;
        this.visibilidade.aguardarIntegracao =
          etapa.ordem === EtapaDoPedido.PedidoIntegrado ||
          etapa.ordem === EtapaDoPedido.AguardandoFaturamentoFinanciamento ||
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoRecursoProprio;
        this.visibilidade.aguardarValidacao = etapa.ordem === EtapaDoPedido.AguardandoIntegracao;
        break;

      // financiamento
      case 2:
        this.visibilidade.faturar = etapa.ordem === EtapaDoPedido.AguardandoFaturamentoFinanciamento;
        this.visibilidade.imprimirNota = etapa.ordem === EtapaDoPedido.PedidoFaturadoFinanciamento;
        this.tipoNota = 0;
        this.visibilidade.anexos = true;
        break;

      // financeiro
      case 3:
        this.visibilidade.resumoFinanceiro = true;
        this.visibilidade.aprovar =
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoRecursoProprio ||
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoFinanciamento;
        this.visibilidade.reprovar =
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoRecursoProprio ||
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoFinanciamento ||
          etapa.ordem === EtapaDoPedido.AguardandoConferenciaPagamento;
        this.visibilidade.conferirPagamento = etapa.ordem === EtapaDoPedido.AguardandoConferenciaPagamento;
        this.visibilidade.verJustificativa = etapa.ordem === EtapaDoPedido.PagamentoReprovado;
        this.visibilidade.verRecebimentos =
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoRecursoProprio ||
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoFinanciamento ||
          etapa.ordem === EtapaDoPedido.PagamentoAprovado ||
          etapa.ordem === EtapaDoPedido.AguardandoConferenciaTriagem;
        this.visibilidade.podeEditarRecebimentos =
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoRecursoProprio ||
          etapa.ordem === EtapaDoPedido.AguardandoPagamentoFinanciamento ||
          etapa.ordem === EtapaDoPedido.AguardandoConferenciaTriagem;
        break;

      // separação
      case 4:
        this.visibilidade.emSeparacao =
          etapa.ordem === EtapaDoPedido.EmImportacao && this.premissas.habilitarEtapaEmImportacao;
        this.visibilidade.emImportacao =
          etapa.ordem === EtapaDoPedido.AguardandoSeparacao && this.premissas.habilitarEtapaEmImportacao;
        this.visibilidade.conferir =
          etapa.ordem === EtapaDoPedido.AguardandoSeparacao || etapa.ordem === EtapaDoPedido.AguardandoDadosTransporte;
        this.visibilidade.verProdutoLote = this.premissas.usaProdutoLote;
        break;

      // faturamento
      case 5:
        this.visibilidade.imprimirNota = true;
        this.visibilidade.vincularNota = etapa.ordem === EtapaDoPedido.AguardandoNFe;
        this.visibilidade.faturar = etapa.ordem === EtapaDoPedido.AguardandoFaturamentoSemFinanciamento;
        this.visibilidade.verProdutoLote = this.premissas.usaProdutoLote;
        break;

      // expedição
      case 6:
        this.visibilidade.despachar = etapa.ordem === EtapaDoPedido.AguardandoTransporte;
        this.visibilidade.entregar = etapa.ordem === EtapaDoPedido.PedidoColetado;
        this.visibilidade.separar = etapa.ordem === EtapaDoPedido.AguardandoSeparacaoExpedicao;
        this.visibilidade.verProdutoLote = this.premissas.usaProdutoLote;
        break;

      case 10:
        this.buscouPedidos = true;
        this.visibilidade.tagsDoPedido = false;
        this.visibilidade.anexos = true;
        this.visibilidade.historico = true;
        break;

      // conferencia
      case 12:
        this.visibilidade.conferirTec = etapa.ordem === EtapaDoPedido.AguardandoConferencia;
        this.visibilidade.editar = etapa.ordem === EtapaDoPedido.AguardandoConferencia;
        this.visibilidade.aguardarValidacao = etapa.ordem === EtapaDoPedido.AguardandoConferencia;
        break;

      // verificacao
      case 13:
        this.visibilidade.verificarTec = etapa.ordem === EtapaDoPedido.AguardandoVerificacao;
        break;

      // analise financeira
      case 14:
        this.visibilidade.aprovarBancoTec = etapa.ordem === EtapaDoPedido.AguardandoAnaliseBanco;
        this.visibilidade.aprovarFinanceiroTec = etapa.ordem === EtapaDoPedido.AguardandoAnaliseCredito;
        break;

      // verificacao
      case 15:
        this.visibilidade.faturarTec = etapa.ordem === EtapaDoPedido.AguardandoFaturamento;
        break;

      // triagem
      case 16:
        this.visibilidade.emPendencia = etapa.ordem === EtapaDoPedido.AguardandoTriagem;
        this.visibilidade.aprovarTriagem = etapa.ordem === EtapaDoPedido.AguardandoTriagem;
        // this.visibilidade.ordenacao = etapa.ordem === EtapaDoPedido.AguardandoTriagem;

        if (!contem) {
          const ordem = { id: 2, nome: 'Qtd. foi resolvido' };
          this.ordenacoesTriagem.push(ordem);
        }

        this.ordenacoesTriagem;
        this.visibilidade.historico = true;

        this.visibilidade.resumoFinanceiro =
          etapa.ordem === EtapaDoPedido.AguardandoTriagem ||
          etapa.ordem === EtapaDoPedido.Em_Pendencia ||
          etapa.ordem === EtapaDoPedido.AguardandoConferenciaTriagem;
        this.visibilidade.verRecebimentos =
          etapa.ordem === EtapaDoPedido.AguardandoTriagem ||
          etapa.ordem === EtapaDoPedido.Em_Pendencia ||
          etapa.ordem === EtapaDoPedido.AguardandoConferenciaTriagem;
        this.visibilidade.podeEditarRecebimentos =
          etapa.ordem === EtapaDoPedido.AguardandoTriagem ||
          etapa.ordem === EtapaDoPedido.Em_Pendencia ||
          etapa.ordem === EtapaDoPedido.AguardandoConferenciaTriagem;

        this.visibilidade.resolverPendencia = etapa.ordem === EtapaDoPedido.Em_Pendencia;
        this.visibilidade.aprovarPedido = etapa.ordem === EtapaDoPedido.AguardandoConferenciaTriagem;
        this.visibilidade.aguardarTriagem = etapa.ordem === EtapaDoPedido.AguardandoConferenciaTriagem;
        break;

      // pendência
      case 17:
        this.visibilidade.resolverPendencia = etapa.ordem === EtapaDoPedido.Em_Pendencia;
        // this.visibilidade.ordenacao = etapa.ordem === EtapaDoPedido.Em_Pendencia;
        this.visibilidade.historico = true;

        if (!contem) {
          const ordem = { id: 2, nome: 'Qtd. foi resolvido' };
          this.ordenacoesTriagem.push(ordem);
        }

        break;

      default:
        break;
    }
  }

  async buscarPendencias() {
    try {
      this.pendencias = await this.pendenciaService.consultarPendencias().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  ngOnDestroy(): void {
    this.destroySubscriptionPedidos();
    this.destroySubscriptionTotais();
    this.destroySubscriptionPedidoSumario();
  }

  resumoDoPedido(pedido: Pedido) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(ResumoModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        somenteLeitura: true,
        ocultarValores: !this.monitores.some((p) => p.monitor === this.tipo && p.mostrarValores),
        mostrarDescontoItens: this.tipo === 3,
        exibirConcordarTermos: false,
        mostrarResumoFinanceiro: this.visibilidade.resumoFinanceiro,
        mostrarRecebimentos: this.visibilidade.verRecebimentos,
        podeEditarRecebimentos: this.visibilidade.podeEditarRecebimentos,
        mostrarPrevisaoEntrega: this.visibilidade.entregar,
        tipo: this.tipo
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  resumoFinanceiroDoPedido(pedido: Pedido) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(ResumoFinanceiroModalComponent, {
      width: $('body').width().toString() + 'px',
      data: { idCupom: pedido.idCupom, valorTotal: pedido.valorTotal },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  async executaAcao(pedido: PedidoLista, acao: AcaoAcompanhamento) {
    let msg = '';
    let skipMessage = false;

    switch (acao) {
      case AcaoAcompanhamento.Aprovar:
        msg = 'Deseja realmente APROVAR esse pedido?';
        break;

      case AcaoAcompanhamento.ConferirPagamento:
        msg = 'Deseja realmente VALIDAR O PAGAMENTO esse pedido?';
        break;

      case AcaoAcompanhamento.Despachar:
        msg = 'Deseja realmente DESPACHAR esse pedido?';
        break;

      case AcaoAcompanhamento.Entregar:
        msg = 'Deseja realmente ENTREGAR esse pedido?';
        break;

      case AcaoAcompanhamento.Reprovar:
        msg = 'Deseja realmente REPROVAR esse pedido?';
        break;

      case AcaoAcompanhamento.Separar:
        msg = 'Deseja realmente SEPARAR esse pedido?';
        break;

      case AcaoAcompanhamento.AguardarIntegracao:
        msg = 'Deseja realmente VOLTAR esse pedido para AGUARDANDO INTEGRAÇÃO?';
        break;

      case AcaoAcompanhamento.AguardarValidacao:
        msg = `Deseja realmente VOLTAR esse pedido para ${this.retornarNomeEtapaParaVoltar(pedido).toUpperCase()}?`;
        break;

      case AcaoAcompanhamento.VincularNotaFiscal:
        if (this.dadosObgMonitores) {
          msg = 'Deseja realmente VINCULAR UMA NOTA FISCAL para esse pedido?';
        } else {
          msg = 'Deseja realmente APROVAR ESTA ETAPA para esse pedido?';
        }

        break;

      case AcaoAcompanhamento.FaturarFinanciamento:
      case AcaoAcompanhamento.FaturarSemFinanciamento:
        if (this.dadosObgMonitores) {
          msg = 'Deseja realmente VINCULAR UMA NOTA FISCAL DE FATURAMENTO para esse pedido?';
        } else {
          msg = 'Deseja realmente APROVAR ESTA ETAPA para esse pedido?';
        }
        break;

      case AcaoAcompanhamento.ConferirSeparacao:
        if (this.informarDadosSeparacao) {
          msg = 'Deseja realmente enviar esse pedido para DADOS DE TRANSPORTE?';
        } else {
          msg = 'Deseja realmente SEPARAR esse pedido?';
        }
        break;

      case AcaoAcompanhamento.ConferirSeparacaoTransporte:
        msg = 'Deseja realmente SEPARAR esse pedido?';
        break;

      case AcaoAcompanhamento.Integrar:
        msg = 'Deseja realmente INTEGRAR esse pedido?';
        break;

      case AcaoAcompanhamento.Conferir:
        msg = 'Deseja realmente CONFERIR esse pedido?';
        break;

      case AcaoAcompanhamento.Verificar:
        msg = 'Deseja realmente VERIFICAR esse pedido?';
        break;

      case AcaoAcompanhamento.AprovarBanco:
      case AcaoAcompanhamento.AprovarFinanceiro:
        msg = 'Deseja realmente APROVAR esse pedido?';
        break;

      case AcaoAcompanhamento.Faturar:
        msg = 'Deseja realmente FATURAR esse pedido?';
        break;

      case AcaoAcompanhamento.EmPendencia:
        skipMessage = await this.abrirModalCadastroPendencias(pedido, 'cadastro');

        msg = 'Deseja realmente MARCAR esse pedido como PENDENTE?';

        break;

      case AcaoAcompanhamento.AprovarTriagem:
        msg = 'Deseja realmente LIBERAR esse pedido?';

        break;

      case AcaoAcompanhamento.ResolverPendencia:
        skipMessage = await this.abrirModalCadastroPendencias(pedido, 'resolver');

        msg = 'Deseja realmente RESOLVER a(s) PENDÊNCIA(S) desse pedido?';
        break;

      case AcaoAcompanhamento.AprovarConferenciaTriagem:
        msg = 'Deseja realmente APROVAR esse pedido?';
        break;

      case AcaoAcompanhamento.VoltarPedidoParaAguardandoTriagem:
        msg = 'Deseja realmente VOLTAR o pedido para AGUARDANDO TRIAGEM?';
        break;

      case AcaoAcompanhamento.EmImportacao:
        msg = 'Deseja realmente VOLTAR o pedido para EM IMPORTAÇÃO?';
        break;

      case AcaoAcompanhamento.EmSeparacao:
        msg = 'Deseja realmente ENVIAR o pedido para AGUARDANDO SEPARAÇÃO?';
        break;

      default:
        break;
    }

    if (skipMessage) return;

    swal({
      title: 'Atenção!!',
      text: msg,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        if (acao == AcaoAcompanhamento.Reprovar) {
          const largura = Number($('body').width());

          const dialogRef = this.dialog.open(JustificativaModalComponent, {
            width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
            data: { tipo: 0, idCupom: pedido.idCupom },
            panelClass: 'modal-card'
          });

          dialogRef.afterClosed().subscribe((resultJust) => {
            if (resultJust) {
              this.carregandoService.mostra('salvaHistoricoEtapas');

              const historico = new EtapaPedido();
              historico.idCupom = pedido.idCupom;
              historico.acao = acao;
              historico.justificativa = resultJust;

              this.etapaService.salvarHistorico(historico).subscribe(
                (resp) => {
                  this.carregandoService.esconde('salvaHistoricoEtapas');
                  this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                  this.buscarPedidos();
                  this.consultarTotais();
                },
                (erro) => {
                  this.carregandoService.esconde('salvaHistoricoEtapas');
                  this.notificacaoService.erro(erro);
                }
              );
            }
          });
        } else if (acao == AcaoAcompanhamento.ConferirSeparacao) {
          if (this.dadosObgMonitores) {
            const largura = Number($('body').width());

            const dialogRef = this.dialog.open(VolumeModalComponent, {
              width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
              data: { idCupom: pedido.idCupom, peso: pedido.pesoBruto },
              panelClass: 'modal-card'
            });

            dialogRef.afterClosed().subscribe((resultVol) => {
              if (resultVol) {
                this.carregandoService.mostra('salvaHistoricoEtapas');

                const historico = new EtapaPedido();
                historico.idCupom = pedido.idCupom;
                historico.acao = acao;
                historico.volume = Number(resultVol.volume);
                historico.dimensao = resultVol.dimensao;
                historico.peso = Number(resultVol.peso);

                this.etapaService.salvarHistorico(historico).subscribe(
                  (resp) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                    this.buscarPedidos();
                    this.consultarTotais();
                  },
                  (erro) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.erro(erro);
                  }
                );
              }
            });
          } else if (this.informarDadosSeparacao) {
            const largura = Number($('body').width());

            const dialogRef = this.dialog.open(DadosMonitoresModalComponent, {
              width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
              data: { idCupom: pedido.idCupom, tipo: this.tipo, peso: pedido.pesoBruto },
              panelClass: 'modal-card'
            });

            dialogRef.afterClosed().subscribe((resultVol) => {
              if (resultVol) {
                this.carregandoService.mostra('salvaHistoricoEtapas');

                const historico = new EtapaPedido();
                historico.idCupom = pedido.idCupom;
                historico.acao = acao;
                historico.dadosSeparacao = resultVol;

                historico.dadosSeparacao.peso = Number(historico.dadosSeparacao.peso);
                historico.dadosSeparacao.volume = Number(historico.dadosSeparacao.volume);

                this.etapaService.salvarHistorico(historico).subscribe(
                  (resp) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                    this.buscarPedidos();
                    this.consultarTotais();
                  },
                  (erro) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.erro(erro);
                  }
                );
              }
            });
          } else {
            this.carregandoService.mostra('salvaHistoricoEtapas');
            const historico = new EtapaPedido();
            historico.idCupom = pedido.idCupom;
            historico.acao = acao;

            this.etapaService.salvarHistorico(historico).subscribe(
              (resp) => {
                this.carregandoService.esconde('salvaHistoricoEtapas');
                this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                this.buscarPedidos();
                this.consultarTotais();
              },
              (erro) => {
                this.carregandoService.esconde('salvaHistoricoEtapas');
                this.notificacaoService.erro(erro);
              }
            );
          }
        } else if (acao == AcaoAcompanhamento.ConferirSeparacaoTransporte) {
          const largura = Number($('body').width());

          const dialogRef = this.dialog.open(DadosMonitoresModalComponent, {
            width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
            data: {
              idCupom: pedido.idCupom,
              tipo: this.tipo,
              idTransportadora: pedido.transportadora,
              separacaoTransporte: true,
              tipoFrete: pedido.tipoFrete,
              valorFrete: pedido.frete
            },
            panelClass: 'modal-card'
          });

          dialogRef.afterClosed().subscribe((resultVol) => {
            if (resultVol) {
              this.carregandoService.mostra('salvaHistoricoEtapas');

              const historico = new EtapaPedido();
              historico.idCupom = pedido.idCupom;
              historico.acao = acao;
              historico.dadosSeparacaoTransporte = resultVol;

              this.etapaService.salvarHistorico(historico).subscribe(
                (resp) => {
                  this.carregandoService.esconde('salvaHistoricoEtapas');
                  this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                  this.buscarPedidos();
                  this.consultarTotais();
                },
                (erro) => {
                  this.carregandoService.esconde('salvaHistoricoEtapas');
                  this.notificacaoService.erro(erro);
                }
              );
            }
          });
        } else if (acao == AcaoAcompanhamento.VincularNotaFiscal) {
          if (this.dadosObgMonitores) {
            const largura = Number($('body').width());

            const dialogRef = this.dialog.open(NotaFiscalModalComponent, {
              width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
              data: { idCupom: pedido.idCupom },
              panelClass: 'modal-card'
            });

            dialogRef.afterClosed().subscribe((resultNota) => {
              if (resultNota) {
                this.carregandoService.mostra('salvaHistoricoEtapas');

                const historico = new EtapaPedido();
                historico.idCupom = pedido.idCupom;
                historico.acao = acao;
                historico.notaFiscal = resultNota;

                this.etapaService.salvarHistorico(historico).subscribe(
                  (resp) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                    this.buscarPedidos();
                    this.consultarTotais();
                  },
                  (erro) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.erro(erro);
                  }
                );
              }
            });
          } else {
            this.carregandoService.mostra('salvaHistoricoEtapas');

            const historico = new EtapaPedido();
            historico.idCupom = pedido.idCupom;
            historico.acao = acao;

            this.etapaService.salvarHistorico(historico).subscribe(
              (resp) => {
                this.carregandoService.esconde('salvaHistoricoEtapas');
                this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                this.buscarPedidos();
                this.consultarTotais();
              },
              (erro) => {
                this.carregandoService.esconde('salvaHistoricoEtapas');
                this.notificacaoService.erro(erro);
              }
            );
          }
        } else if (
          acao == AcaoAcompanhamento.FaturarFinanciamento ||
          acao == AcaoAcompanhamento.FaturarSemFinanciamento
        ) {
          if (this.dadosObgMonitores) {
            const largura = Number($('body').width());

            const dialogRef = this.dialog.open(NotaFiscalModalComponent, {
              width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
              data: { idCupom: pedido.idCupom, financiamento: true },
              panelClass: 'modal-card'
            });

            dialogRef.afterClosed().subscribe((resultNota) => {
              if (resultNota) {
                this.carregandoService.mostra('salvaHistoricoEtapas');

                const historico = new EtapaPedido();
                historico.idCupom = pedido.idCupom;
                historico.acao = acao;
                historico.notaFiscal = resultNota;

                this.etapaService.salvarHistorico(historico).subscribe(
                  (resp) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                    this.buscarPedidos();
                    this.consultarTotais();
                  },
                  (erro) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.erro(erro);
                  }
                );
              }
            });
          } else {
            this.carregandoService.mostra('salvaHistoricoEtapas');

            const historico = new EtapaPedido();
            historico.idCupom = pedido.idCupom;
            historico.acao = acao;

            this.etapaService.salvarHistorico(historico).subscribe(
              (resp) => {
                this.carregandoService.esconde('salvaHistoricoEtapas');
                this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                this.buscarPedidos();
                this.consultarTotais();
              },
              (erro) => {
                this.carregandoService.esconde('salvaHistoricoEtapas');
                this.notificacaoService.erro(erro);
              }
            );
          }
        } else if (acao == AcaoAcompanhamento.Integrar) {
          if (this.pedirCodErpIntegracao) {
            const largura = Number($('body').width());

            const dialogRef = this.dialog.open(DadosMonitoresModalComponent, {
              width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
              data: { idCupom: pedido.idCupom, tipo: this.tipo, codErp: pedido.codErp },
              panelClass: 'modal-card'
            });

            dialogRef.afterClosed().subscribe((resultVol) => {
              if (resultVol) {
                this.carregandoService.mostra('salvaHistoricoEtapas');

                const historico = new EtapaPedido();
                historico.idCupom = pedido.idCupom;
                historico.acao = acao;
                historico.codErp = resultVol.codErp;

                this.etapaService.salvarHistorico(historico).subscribe(
                  (resp) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                    this.buscarPedidos();
                    this.consultarTotais();
                  },
                  (erro) => {
                    this.carregandoService.esconde('salvaHistoricoEtapas');
                    this.notificacaoService.erro(erro);
                  }
                );
              }
            });
          } else {
            this.carregandoService.mostra('salvaHistoricoEtapas');
            const historico = new EtapaPedido();
            historico.idCupom = pedido.idCupom;
            historico.acao = acao;

            this.etapaService.salvarHistorico(historico).subscribe(
              (resp) => {
                this.carregandoService.esconde('salvaHistoricoEtapas');
                this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
                this.buscarPedidos();
                this.consultarTotais();
              },
              (erro) => {
                this.carregandoService.esconde('salvaHistoricoEtapas');
                this.notificacaoService.erro(erro);
              }
            );
          }
        } else {
          this.carregandoService.mostra('salvaHistoricoEtapas');

          const historico = new EtapaPedido();
          historico.idCupom = pedido.idCupom;
          historico.acao = acao;

          this.etapaService.salvarHistorico(historico).subscribe(
            (resp) => {
              this.carregandoService.esconde('salvaHistoricoEtapas');
              this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
              this.buscarPedidos();
              this.consultarTotais();
            },
            (erro) => {
              this.carregandoService.esconde('salvaHistoricoEtapas');
              this.notificacaoService.erro(erro);
            }
          );
        }
      }
    });
  }

  alterarVisualizacao(visualizacao) {
    if (this.visualizacaoSelecionada === visualizacao) {
      return;
    }

    this.visualizacaoSelecionada = visualizacao;

    if (this.tipo === 10) {
      this.buscouPedidos = true;
      this.limpaPedidos();
    } else {
      this.buscarPedidos();
      this.consultarTotais();
    }
  }

  alterarEtapaFiltro(etapa, somenteApi) {
    this.etapaSelecionada = etapa;
    this.somenteApi = somenteApi;
    this.buscarPedidos();
    this.consultarTotais();
    this.paginator.firstPage();
  }

  imprimirNota(pedido: Pedido) {
    this.carregandoService.mostra('imprimirNota');

    this.notaFiscalService.imprimirNotaPorIdCupom(pedido.idCupom, this.tipoNota).subscribe(
      (resp) => {
        this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
        this.utilitarioService.openBlob(resp);

        this.carregandoService.esconde('imprimirNota');
      },
      (erro) => {
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement['result'];
          this.carregandoService.esconde('imprimirNota');
          this.notificacaoService.erro(text);
        });

        // Start reading the blob as text.
        reader.readAsText(erro.error);
      }
    );
  }

  // 0 - faturamento | 1- fiscal
  imprimirNotaPorTipo(pedido: Pedido, tipoNota) {
    this.carregandoService.mostra('imprimirNota');

    this.notaFiscalService.imprimirNotaPorIdCupom(pedido.idCupom, tipoNota).subscribe(
      (resp) => {
        this.utilitarioService.openBlob(resp);
        this.carregandoService.esconde('imprimirNota');
      },
      (erro) => {
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement['result'];
          this.carregandoService.esconde('imprimirNota');
          this.notificacaoService.erro(text);
        });

        // Start reading the blob as text.
        reader.readAsText(erro.error);
      }
    );
  }

  anexos(pedido: Pedido) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(PedidoAnexoComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        idPedido: pedido.idCupom,
        podeEditar: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarPedidos();
      }
    });
  }

  buscarDadosObgMonitores() {
    this.premissasService.consultarDadosObgMonitores().subscribe(
      (f) => {
        this.dadosObgMonitores = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  notasFiscais(pedido: Pedido) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(NotaFiscalPedidoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        podeAdicionarNota:
          this.tipo == 2 || this.tipo == 5 || (this.tipo == 6 && pedido.ordemEtapa == 16) || this.tipo == 4
      },
      panelClass: 'modal-card'
    });
  }

  exibirObservacoes(pedido: Pedido) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(ObservacoesModalComponent, {
      width: largura > 1050 ? '1000px' : $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        pedido: pedido,
        podeAdicionarNota: this.tipo == 2 || this.tipo == 5 || (this.tipo == 6 && pedido.ordemEtapa == 16)
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.buscarPedidos();
    });
  }

  exibirRecebimentos(pedido: Pedido) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(PedidoRecebimentoModalComponent, {
      width: largura > 1050 ? '1000px' : $('body').width().toString() + 'px',
      data: { idCupom: pedido.idCupom },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  buscarVendedores() {
    if (!this.pesquisaPorTimes && (this.administrador || (this.tipo !== 0 && this.tipo !== 17))) {
      this.funcionarioService.consultarFuncionariosPedido().subscribe(
        (resp) => {
          this.vendedores = resp.map((p) => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));
          if (this.vendedores.length > 1) {
            this.vendedores.unshift({ idFuncion: 0, nome: 'Todos' });
          }
        },
        (erro) => {
          this.notificacaoService.erro(erro);
        }
      );
    } else {
      this.hierarquiaService
        .consultarHierarquiaDoUsuarioLista(
          undefined,
          this.pesquisaPorTimes,
          undefined,
          this.tipo !== 0 && this.tipo !== 17
        )
        .subscribe(
          (resp) => {
            this.vendedores = resp;

            this.vendedores.splice(
              this.vendedores.indexOf(this.vendedores.find((p) => p.idFuncion === Number(this.usuarioLogado.id))),
              1
            );

            if (this.vendedores.length > 0) {
              const todos = new CRMHierarquiaUsuario();
              todos.idFuncion = 0;
              todos.nome = 'Todos';
              this.vendedores.unshift(todos);
            }

            const somenteEu = new CRMHierarquiaUsuario();
            somenteEu.idFuncion = -1;
            somenteEu.nome = 'Somente eu';
            this.vendedores.unshift(somenteEu);
          },
          (erro) => {
            this.notificacaoService.erro(erro);
          }
        );
    }
  }

  buscarClientes() {
    this.filtroPedido.integrador = undefined;
    this.clienteService
      .consultarClientesDoVendedor(
        this.filtroPedido.funcionario === 0
          ? undefined
          : this.filtroPedido.funcionario === -1
            ? this.usuarioLogado.id
            : this.filtroPedido.funcionario
      )
      .subscribe(
        (resp) => {
          this.clientes = resp;

          const todos = new Cliente();
          todos.id = undefined;
          todos.nome = 'Todos';
          this.clientes.unshift(todos);
        },
        (erro) => {
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarFormasDePagamento() {
    this.formadePagamentoService.consultar().subscribe(
      (forms) => {
        this.formasDePagamento = forms;
        if (
          this.formaDePagamentoSelecionado !== null &&
          this.formaDePagamentoSelecionado !== undefined &&
          this.formaDePagamentoSelecionado.length === 1
        ) {
          this.buscarCondicoesDePagamento();
        }
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarCondicoesDePagamento() {
    if (
      this.formaDePagamentoSelecionado !== null &&
      this.formaDePagamentoSelecionado !== undefined &&
      this.formaDePagamentoSelecionado.length === 1
    ) {
      this.condicaoDePagamentoService.consultarPorForma(this.formaDePagamentoSelecionado[0]).subscribe(
        (conds) => {
          this.condicoesDePagamento = conds;
          if (
            this.condicaoDePagamentoSelecionado === null ||
            this.condicaoDePagamentoSelecionado === undefined ||
            !this.condicoesDePagamento.some((c) => c.idCondPag === this.condicaoDePagamentoSelecionado[0])
          ) {
            this.condicaoDePagamentoSelecionado = [];
          }
        },
        (erro) => {
          this.notificacaoService.erro(erro);
        }
      );
    } else {
      this.condicoesDePagamento = [];
      this.condicaoDePagamentoSelecionado = undefined;
    }
  }

  selecionarTag(pedido: PedidoLista) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(SelecionarTagModalComponent, {
      width: largura > 850 ? '800px' : $('body').width().toString() + 'px',
      data: { idCupom: pedido.idCupom, tags: pedido.tags.map((t) => t.id), tipo: TipoTag.pedido },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        pedido.buscouTags = false;

        this.buscarPedidoSumario(pedido);

        // pedido.tags = await this.buscarPedidoSumario(pedido.idCupom);
        // pedido.buscouTags = true;
      }
    });
  }

  buscarTags() {
    this.tagService.consultarTags(TipoTag.pedido).subscribe(
      (tags) => {
        this.tags = tags;
        this.tags.unshift({
          id: -1,
          tag: 'Sem tags',
          icone: 'label_off',
          cor: '#000',
          tipo: this.tipo,
          somenteApi: false,
          disabled: false,
          tipoVinculo: 0
        });
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true,
        pesquisarPorVendedor: true,
        idVendedor: this.filtroPedido.funcionario === -1 ? this.usuarioLogado.id : this.filtroPedido.funcionario
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.filtroPedido.integrador = result.cliente.id;
      }
    });
  }

  pesquisaGeralCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true,
        pesquisaGeral: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
      }
    });
  }

  podePesquisar() {
    return (
      (this.tipo !== 10 ||
        this.filtroPedido.idCupom ||
        this.filtroPedido.dtInicio ||
        this.filtroPedido.dtFim ||
        this.filtroPedido.funcionario ||
        this.filtroPedido.integrador ||
        this.formaDePagamentoSelecionado ||
        this.condicaoDePagamentoSelecionado ||
        this.filtroPedido.valorDe ||
        this.filtroPedido.valorAte ||
        this.tagsSelecionadas.length > 0 ||
        this.filtroPedido.referencia ||
        this.filtroPedido.idFornecedor ||
        this.filtroPedido.nfe) &&
      this.filtroCodErpProdutoValido()
    );
  }

  filtroCodErpProdutoValido() {
    if (!this.filtroPedido.codErpProduto) {
      return true;
    }

    if (!this.filtroPedido.dtInicio || !this.filtroPedido.dtFim) {
      return false;
    }

    return !this.excedeuLimiteDiasCodErpProduto();
  }

  verificarPeriodoCodErpProduto() {
    if (this.filtroPedido.codErpProduto && this.excedeuLimiteDiasCodErpProduto()) {
      /*
        setTimeout garante que a limpeza ocorra após o MatDatepickerInput
        terminar de escrever o valor selecionado no próprio input, evitando
        que o campo que disparou o (dateChange) sobrescreva o undefined.
      */
      setTimeout(() => {
        this.filtroPedido.dtInicio = undefined;
        this.filtroPedido.dtFim = undefined;
      });

      this.notificacaoService.aviso(
        'O intervalo entre as Datas de Início e Fim deve ser de no máximo 30 dias quando o Cód. ERP do Produto for informado.'
      );
    }
  }

  mensagemAvisoCodErpProduto() {
    if (!this.filtroPedido.dtInicio || !this.filtroPedido.dtFim) {
      return 'Informe as Datas de Início e Fim para pesquisar por Cód. ERP do Produto.';
    }

    return 'O intervalo entre as datas deve ser de no máximo 30 dias.';
  }

  excedeuLimiteDiasCodErpProduto() {
    if (!this.filtroPedido.dtInicio || !this.filtroPedido.dtFim) {
      return false;
    }

    const dtInicio = new Date(this.filtroPedido.dtInicio);
    const dtFim = new Date(this.filtroPedido.dtFim);

    const diferencaEmDias = Math.ceil((dtFim.getTime() - dtInicio.getTime()) / (1000 * 60 * 60 * 24));

    return diferencaEmDias > 30;
  }

  abrirBoleto(pedido: Pedido) {
    this.carregandoService.mostra('abrirBoleto');

    if (this.boletoFotus) {
      this.pedidoService.buscarCryptCupomFotus(pedido.idCupom).subscribe(
        ({ result }) => {
          this.carregandoService.esconde('abrirBoleto');
          this.notificacaoService.sucesso('Boleto aberto em outra aba com sucesso!!!');
          window.open('https://cliente.fotus.com.br/boletos?text=' + result, '_blank');
        },
        (err) => {
          this.carregandoService.esconde('abrirBoleto');
          this.notificacaoService.erro(err);
        }
      );
    } else {
      this.pedidoService.buscarListaArqBoleto(pedido.idCupom).subscribe(
        ({ fileNames }) => {
          this.carregandoService.esconde('abrirBoleto');

          if (fileNames.length > 0) {
            fileNames = fileNames.filter((p) => p !== '');
          }

          if (fileNames.length > 0) {
            const largura = Number($('body').width());

            const dialogRef = this.dialog.open(SelecionarArquivoBoletoPedidoModalComponent, {
              width: largura > 500 ? '550px' : $('body').width().toString() + 'px',
              data: { fileNames: fileNames },
              panelClass: 'modal-card'
            });

            dialogRef.afterClosed().subscribe((fileName) => {
              if (fileName) {
                this.abrirBoletoSelecionado(pedido.idCupom, fileName);
              }
            });
          } else {
            this.notificacaoService.erro('Não existem boletos lançados para este pedido.');
          }
        },
        (err) => {
          this.carregandoService.esconde('abrirBoleto');
          this.notificacaoService.erro(err);
        }
      );
    }
  }

  abrirBoletoSelecionado(idCupom, fileName) {
    this.carregandoService.mostra('baixarBoletoSelecionado');
    this.pedidoService.baixarBoletoPedido(idCupom, fileName).subscribe(
      (arq) => {
        this.utilitarioService.openBlobModal(arq, fileName);
        this.carregandoService.esconde('baixarBoletoSelecionado');
      },
      (err) => {
        this.carregandoService.esconde('baixarBoletoSelecionado');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarPremissaBoletoFotus() {
    this.premissasService.consultarBoletoFotus().subscribe(
      (dados) => {
        this.boletoFotus = dados.valor;
      },
      (err) => {
        this.notificacaoService.erro(err);
      }
    );
  }

  abrirModalOcorrencias(pedido: PedidoLista) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(SelecionarOcorrenciaModalComponent, {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      data: { idCupom: pedido.idCupom, tipo: this.tipo },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  acompanharPedido(pedido: PedidoLista) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(EtapasDoPedidoComponent, {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      data: { idCupom: pedido.idCupom },
      panelClass: 'modal-card'
    });
  }

  buscarMonitores() {
    this.monitorService.consultar().subscribe(
      (dados) => {
        this.monitores = dados;
      },
      (err) => {
        this.notificacaoService.erro(err);
      }
    );
  }

  exportar() {
    this.buscouPedidos = false;
    this.filtroPedido.etapas = this.etapaSelecionada ? [this.etapaSelecionada] : [];
    this.filtroPedido.pendencias = this.pendenciasSelecionadas ? [this.pendenciasSelecionadas] : [];

    let etapas = undefined;
    let pendencias = undefined;
    let formas = undefined;
    let condicoes = undefined;

    if (this.filtroPedido.pendencias && this.filtroPedido.pendencias.length > 0) {
      pendencias = this.filtroPedido.pendencias.join(',');
    }

    if (this.filtroPedido.etapas && this.filtroPedido.etapas.length > 0) {
      etapas = this.filtroPedido.etapas.join(',');
    }

    if (this.formaDePagamentoSelecionado && this.formaDePagamentoSelecionado.length > 0) {
      formas = this.formaDePagamentoSelecionado.join(',');
    }

    if (this.condicaoDePagamentoSelecionado && this.condicaoDePagamentoSelecionado.length > 0) {
      condicoes = this.condicaoDePagamentoSelecionado.join(',');
    }

    this.carregandoService.mostra('Exportar');

    this.pedidoService
      .exportarConsultaMonitor(
        this.paginacao.paginaAtual,
        this.itensPorPagina,
        this.visualizacaoSelecionada === 0 ? 'dataetapa' : this.campoOrdenacao,
        this.visualizacaoSelecionada === 0
          ? this.visibilidade.ordenacao
            ? this.direcaoTriagem
            : 'asc'
          : this.ordenarDesc
            ? 'desc'
            : 'asc',
        this.filtroPedido.dtInicio ? this.filtroPedido.dtInicio.toISOString() : this.filtroPedido.dtInicio,
        this.filtroPedido.dtFim ? this.filtroPedido.dtFim.toISOString() : this.filtroPedido.dtFim,
        this.filtroPedido.nomeCliente,
        this.filtroPedido.idCupom,
        this.filtroPedido.status,
        this.filtroPedido.funcionario === 0
          ? undefined
          : this.filtroPedido.funcionario === -1
            ? this.usuarioLogado.id
            : this.filtroPedido.funcionario,
        etapas,
        false,
        true,
        this.filtroPedido.integrador,
        this.filtroPedido.orcStatus,
        formas,
        condicoes,
        this.filtroPedido.valorDe,
        this.filtroPedido.valorAte,
        this.tagsSelecionadas !== null && this.tagsSelecionadas !== undefined && this.tagsSelecionadas.length > 0
          ? this.tagsSelecionadas.join(',')
          : undefined,
        this.tipo,
        null,
        null,
        this.tipo === 10 ? null : this.tipoFiltroDataSelecionado,
        null,
        this.filtroPedido.referencia,
        this.filtroPedido.idFornecedor,
        this.filtroPedido.codErp,
        this.visualizacaoSelecionada === 0 && this.visibilidade.ordenacao ? this.ordenacaoTriagem : null,
        this.filtroPedido.nfe,
        this.entregaRuralSelecionada,
        this.possuiVendaDireta,
        this.valorFiltroDescontoDe,
        this.valorFiltroDescontoAte,
        this.possuiServico,
        this.tipoFrete,
        this.tipoPendencia,
        pendencias,
        this.substituicao,
        this.filtroPedido.possuiRespostaAnaliseDesconto,
        this.pesquisaPorTimes,
        this.filtroPedido.cidadeCdSelecionado,
        this.filtroPedido.codErpProduto
      )
      .subscribe(
        (arq) => {
          this.utilitarioService.saveBlob(arq, 'MonitorPedidos.xlsx');
          this.buscouPedidos = true;
          this.carregandoService.esconde('Exportar');
        },
        (err) => {
          this.buscouPedidos = true;
          this.notificacaoService.erro(err);
          this.carregandoService.esconde('Exportar');
        }
      );
  }

  abrirModalCadastroPendencias(pedido, tipo: string) {
    let skipMessage = false;
    return new Promise<boolean>((resolve) => {
      const dialogRef = this.dialog.open(CadastrarPendenciaModalComponent, {
        width: '1200px',
        data: {
          idCupom: pedido.idCupom,
          cadastro: tipo == 'cadastro',
          possuiPendencias: pedido.possuiPendencias
        },
        disableClose: true,
        panelClass: 'modal-card'
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (
          result != undefined &&
          result.pendencias.length > 0 &&
          ((tipo == 'resolver' && result.resolvido) || tipo == 'cadastro')
        ) {
          skipMessage = false;
          resolve(skipMessage);
        } else {
          skipMessage = true;
          resolve(skipMessage);
        }
      });
    });
  }

  MontarLogTooltipTag(tag) {
    return `${tag.tag}: ${tag.nomeUsuario} - ${
      tag.dataHora != undefined ? this.datePipe.transform(tag.dataHora, 'dd/MM/yyyy HH:mm:ss') : ''
    }`;
  }

  verificaRange() {
    const isNullOrUndefined = (value: any) => value === null || value === undefined;

    if (!isNullOrUndefined(this.valorFiltroDescontoDe) && !isNullOrUndefined(this.valorFiltroDescontoAte)) {
      if (Number(this.valorFiltroDescontoAte) > 100) {
        this.notificacaoService.erro('O valor máx do campo Desc Até é 100.');
        this.valorFiltroDescontoAte = 100;
      } else if (Number(this.valorFiltroDescontoDe) > 100) {
        this.notificacaoService.erro('O valor máx do campo Desc De é 100.');
        this.valorFiltroDescontoDe = 100;
      }

      if (Number(this.valorFiltroDescontoDe) > Number(this.valorFiltroDescontoAte)) {
        this.notificacaoService.erro('O valor do campo Desc De deve ser menor que o do campo Desc Até.');
        [this.valorFiltroDescontoDe, this.valorFiltroDescontoAte] = [
          this.valorFiltroDescontoAte,
          this.valorFiltroDescontoDe
        ];
      }
    }
  }

  abrirAnaliseDeDesconto(pedido: PedidoLista) {
    const dialogRef = this.dialog.open(AnaliseDescontoSolicitacaoModalComponent, {
      width: '1078px',
      data: {
        idCupom: pedido.idCupom
      },
      panelClass: ['modal-card', 'modal-card-v2']
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        pedido.possuiAnaliseDesconto = true;
      }
    });
  }

  retornaCorAnaliseDesconto(status: AnaliseDescontoStatus) {
    if (status === undefined || status === null) {
      return 'btn-dark';
    }

    switch (status) {
      case AnaliseDescontoStatus.DescontoConcedido:
        return 'btn-success';

      case AnaliseDescontoStatus.DescontoNaoConcedido:
        return 'btn-danger';

      default:
        return 'btn-primary';
    }
  }

  irParaMonitorConferenciaTarefas() {
    this.router.navigate(['/monitoramento-conferencia-fila-tarefa']);
  }

  selecionarLotes(pedido: PedidoLista | Pedido) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(VendaItemLotesModalComponent, {
      width: largura > 1050 ? '1000px' : $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        somenteLeitura: this.ordemSelecionada !== pedido.ordemEtapa
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  retornarNomeEtapaParaVoltar(pedido: PedidoLista): string {
    if (
      this.premissas !== null &&
      this.premissas !== undefined &&
      this.premissas.naoValidarPedido &&
      this.premissas.origensParaNaoValidarPedido !== null &&
      this.premissas.origensParaNaoValidarPedido !== undefined &&
      this.premissas.origensParaNaoValidarPedido.some((p) => Number(p) === pedido.origemGI)
    )
      return 'Editando';

    return 'Aguardando Validação';
  }
}
